/**
 * SB6-ANA-CACHE-03 — human-readable byte formatting for the storage UI.
 * Base-1024 units (matches how browsers report Cache Storage quota). Used for
 * per-dataset sizes and the total-usage headline.
 */
const UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes) || bytes <= 0) return "0 B";
  const i = Math.min(
    UNITS.length - 1,
    Math.floor(Math.log(bytes) / Math.log(1024)),
  );
  const value = bytes / 1024 ** i;
  const decimals = value >= 100 || i === 0 ? 0 : value >= 10 ? 1 : 2;
  const unit = UNITS[i] ?? "B";
  return `${value.toFixed(decimals)} ${unit}`;
}

/** Parse a GB number from the budget input back into bytes. */
export function gbToBytes(gb: number): number {
  return Math.round(gb * 1024 * 1024 * 1024);
}

/** Bytes → GB (for display in the budget input). */
export function bytesToGb(bytes: number): number {
  return bytes / (1024 * 1024 * 1024);
}
